import { takeLatest, put, call } from 'redux-saga/effects';

import { I18n } from 'src/translations/i18n';
import { importUsersActions } from 'src/store/reducers/importUsersReducer';
import { LOAD_USER_INFO_REQUEST, loadEmployees } from 'src/store/actions/employeesActions';
import toastrError, { getWtsResponseErrorText } from 'src/helpers/toastr/toastrError';
import { edeApi, wtsApi } from 'src/api';
// eslint-disable-next-line import/no-cycle
import store from '../index';

// eslint-disable-next-line func-names
export default function* () {
  yield [
    takeLatest(importUsersActions.meritRequest, importMeritUsersSaga),
    takeLatest(importUsersActions.personaRequest, importPersonaUsersSaga),
    takeLatest(importUsersActions.personaAbsencesRequest, importPersonaAbsencesSaga),
    takeLatest(importUsersActions.request, importUsersSaga),
    takeLatest(importUsersActions.update, updateUserSaga)
  ];
}

function* importPersonaAbsencesSaga({ params }) {
  try {
    const response = yield call(edeApi.persona.importLeavesList, params.request);
    const data = response.data;
    yield put({
      type: importUsersActions.personaSuccess,
      payload: data
    });
    params.callback();
  } catch (err) {
    const { status } = err.response;
    if (status === 500) {
      yield put({
        type: importUsersActions.fail,
        payload: '500'
      });
    } else {
      yield put({
        type: importUsersActions.fail,
        payload: err.message || err.response.data.Message || err.response.data.ResultMsg
      });
    }
    toastrError(err);
  }
}

function* importPersonaUsersSaga({ params }) {
  try {
    const response = yield call(edeApi.persona.importUsersList, params);
    const data = response.data;
    yield put({
      type: importUsersActions.personaSuccess,
      payload: data
    });
    store.dispatch(loadEmployees({ isDeleted: '' }));
  } catch (err) {
    const { status } = err.response;
    if (status === 500) {
      yield put({
        type: importUsersActions.fail,
        payload: '500'
      });
    } else {
      yield put({
        type: importUsersActions.fail,
        payload: err.message || err.response.data.Message || err.response.data.ResultMsg
      });
    }
    toastrError(err);
  }
}

function* importMeritUsersSaga({ params }) {
  try {
    const response = yield call(edeApi.merit.usersCreate, params);
    const data = response.data;
    if (data) {
      yield put({
        type: importUsersActions.success,
        payload: data.data
      });
      store.dispatch(loadEmployees({ isDeleted: '' }));
    } else {
      yield put({
        type: importUsersActions.fail,
        payload: I18n.t('InternalServerError')
      });
    }
  } catch (e) {
    const { status } = e;

    if (status === 500 || status === 400) {
      yield put({
        type: importUsersActions.fail,
        payload: I18n.t('InternalServerError')
      });
    } else {
      const message = yield call(getWtsResponseErrorText, e);
      yield put({
        type: importUsersActions.fail,
        payload: message
      });
    }
  }
}

function* importUsersSaga({ params }) {
  try {
    const response = yield call(wtsApi.imports.usersList, params);
    const data = response.data.Data;
    yield put({
      type: importUsersActions.success,
      payload: data
    });
    store.dispatch(loadEmployees({ isDeleted: '' }));
  } catch (e) {
    toastrError(e);
    const { status } = e;

    if (status === 500 || status === 400) {
      yield put({
        type: importUsersActions.fail,
        payload: I18n.t('InternalServerError')
      });
    } else {
      const message = yield call(getWtsResponseErrorText, e);
      yield put({
        type: importUsersActions.fail,
        payload: message
      });
    }
  }
}

function* updateUserSaga({ params }) {
  try {
    const response = yield call(wtsApi.imports.updateUsersList, params);
    const data = response.data.Data;
    yield put({
      type: importUsersActions.success,
      payload: data
    });
    yield put({ type: LOAD_USER_INFO_REQUEST, userId: { id: params.userIds } });
  } catch (e) {
    toastrError(e);
    const message = yield call(getWtsResponseErrorText, e);

    yield put({
      type: importUsersActions.fail,
      payload: message
    });
  }
}
